import { useState } from 'react';

export function useCadernoInfoGerais(activeWorkspace) {
  const [editingInfoGerais, setEditingInfoGerais] = useState(false);
  const [infoStatus, setInfoStatus] = useState(() => String(activeWorkspace?.status || 'Ativo').trim());
  const [infoNumeroCNJ, setInfoNumeroCNJ] = useState(() => String(activeWorkspace?.numeroCNJ || '').trim());
  const [infoJuizo, setInfoJuizo] = useState(() => String(activeWorkspace?.juizo || '').trim());
  const [infoComarca, setInfoComarca] = useState(() => String(activeWorkspace?.comarca || '').trim());
  const [infoClasse, setInfoClasse] = useState(() => String(activeWorkspace?.metadata?.classe || '').trim());
  const [infoAssunto, setInfoAssunto] = useState(() => String(activeWorkspace?.metadata?.assunto || '').trim());
  const [infoRamo, setInfoRamo] = useState(() => {
    const raw = activeWorkspace?.metadata?.jurisdiction_branch;
    if (Array.isArray(raw)) return raw.join(', ');
    return String(raw || '').trim();
  });
  const [infoValorCausa, setInfoValorCausa] = useState(() => {
    const v = activeWorkspace?.metadata?.valorCausa;
    return v === null || v === undefined ? '' : String(v);
  });
  const [infoValorCondenacao, setInfoValorCondenacao] = useState(() => {
    const v = activeWorkspace?.metadata?.valorCondenacao;
    return v === null || v === undefined ? '' : String(v);
  });
  const [infoDataDistribuicao, setInfoDataDistribuicao] = useState(() =>
    String(activeWorkspace?.metadata?.dataDistribuicao || '').trim(),
  );
  const [infoObjeto, setInfoObjeto] = useState(() =>
    String(activeWorkspace?.metadata?.objeto || '').trim(),
  );
  const [infoFaseProcessual, setInfoFaseProcessual] = useState(() =>
    String(activeWorkspace?.metadata?.faseProcessual || '').trim(),
  );
  const [infoDataPrescricao, setInfoDataPrescricao] = useState(() =>
    String(activeWorkspace?.metadata?.dataPrescricao || '').trim(),
  );

  // Dados Criminais (22/08/2026) — achados reais na tela do Projudi que
  // não tinham campo nenhum no schema: Efeito Suspensivo, Custas, Julgado
  // 2º Grau, Penhora no Rosto, Réu Preso, Data da Prisão, Data do Fato,
  // Delegacia, RAI, Inquérito/Nº SSP. Booleanos usam null como "não
  // informado" (distinto de false = "Não" confirmado) — não inventar um
  // valor quando a fonte não tiver o campo (AGENT_INGESTAO_DADOS_PROCESSO.md §5).
  const [infoEfeitoSuspensivo, setInfoEfeitoSuspensivo] = useState(() => {
    const v = activeWorkspace?.metadata?.efeitoSuspensivo;
    return v === null || v === undefined ? null : Boolean(v);
  });
  const [infoJulgado2Grau, setInfoJulgado2Grau] = useState(() => {
    const v = activeWorkspace?.metadata?.julgado2Grau;
    return v === null || v === undefined ? null : Boolean(v);
  });
  const [infoPenhoraNoRosto, setInfoPenhoraNoRosto] = useState(() => {
    const v = activeWorkspace?.metadata?.penhoraNoRosto;
    return v === null || v === undefined ? null : Boolean(v);
  });
  const [infoReuPreso, setInfoReuPreso] = useState(() => {
    const v = activeWorkspace?.metadata?.reuPreso;
    return v === null || v === undefined ? null : Boolean(v);
  });
  const [infoCustas, setInfoCustas] = useState(() =>
    String(activeWorkspace?.metadata?.custas || '').trim(),
  );
  const [infoDataDaPrisao, setInfoDataDaPrisao] = useState(() =>
    String(activeWorkspace?.metadata?.dataDaPrisao || '').trim(),
  );
  const [infoDataDoFato, setInfoDataDoFato] = useState(() =>
    String(activeWorkspace?.metadata?.dataDoFato || '').trim(),
  );
  const [infoDelegacia, setInfoDelegacia] = useState(() =>
    String(activeWorkspace?.metadata?.delegacia || '').trim(),
  );
  const [infoRai, setInfoRai] = useState(() =>
    String(activeWorkspace?.metadata?.rai || '').trim(),
  );
  const [infoInqueritoNumeroSSP, setInfoInqueritoNumeroSSP] = useState(() =>
    String(activeWorkspace?.metadata?.inqueritoNumeroSSP || '').trim(),
  );

  return {
    editingInfoGerais, setEditingInfoGerais,
    infoStatus, setInfoStatus,
    infoNumeroCNJ, setInfoNumeroCNJ,
    infoJuizo, setInfoJuizo,
    infoComarca, setInfoComarca,
    infoClasse, setInfoClasse,
    infoAssunto, setInfoAssunto,
    infoRamo, setInfoRamo,
    infoValorCausa, setInfoValorCausa,
    infoValorCondenacao, setInfoValorCondenacao,
    infoDataDistribuicao, setInfoDataDistribuicao,
    infoObjeto, setInfoObjeto,
    infoFaseProcessual, setInfoFaseProcessual,
    infoDataPrescricao, setInfoDataPrescricao,
    infoEfeitoSuspensivo, setInfoEfeitoSuspensivo,
    infoJulgado2Grau, setInfoJulgado2Grau,
    infoPenhoraNoRosto, setInfoPenhoraNoRosto,
    infoReuPreso, setInfoReuPreso,
    infoCustas, setInfoCustas,
    infoDataDaPrisao, setInfoDataDaPrisao,
    infoDataDoFato, setInfoDataDoFato,
    infoDelegacia, setInfoDelegacia,
    infoRai, setInfoRai,
    infoInqueritoNumeroSSP, setInfoInqueritoNumeroSSP,
  };
}
